import { useState } from "react";
import { Outlet } from "react-router-dom";
import Header from "./header";
import Sidebar from "./sidebar";

export default function Dashboard() {
    const [sidebarOpen, setSidebarOpen] = useState(false);

    return (
        <>
            <style
                dangerouslySetInnerHTML={{
                    __html: `
						html, body, #root {
							height: 100%;
							width: 100%;
						}
						@media (min-width: 1024px) {
							body {
								overflow: hidden;
							}
						}
					`,
                }}
            />
            <div className="flex flex-col lg:flex-row min-h-screen">
                {/* Sidebar */}
                <div className="lg:block lg:w-64 flex-shrink-0">
                    <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
                </div>

                {/* Content area */}
                <div className="relative flex flex-col flex-1 w-full">
                    {/*  Site header */}
                    <Header sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
                    {/* Main */}
                    <main className="relative bg-gray-100 flex-1 lg:overflow-hidden">
                        <Outlet />
                    </main>
                </div>
            </div>
        </>
    );
}
